import { render, staticRenderFns } from "./kategoribahan.vue?vue&type=template&id=3ef4e18c&scoped=true"
import script from "./kategoribahan.vue?vue&type=script&lang=js"
export * from "./kategoribahan.vue?vue&type=script&lang=js"
import style0 from "./kategoribahan.vue?vue&type=style&index=0&id=3ef4e18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4e18c",
  null
  
)

export default component.exports